<template>

<div class="main list-view">

	<div v-if="!showDetail" class="sub-header">
		<div class="input-with-control">
			<input type="search" ref="search_term" v-model="filters.search_term" placeholder="Search..." @search="getList()" v-focus>
			<div class="button action input-go" @click="getList()"><i class="fas fa-search"></i></div>
		</div>
		<div class="controls">
			<pagination :paging="paging" @updatePage="goToPage"></pagination>
		</div>
	</div>

	<div v-else class="sub-header detail-sub-header">
		<div class="detail-title">{{ listDetail.title }}</div>
	</div>

	<div class="filters">
		<div v-if="showDetail">
			<div :class="['button', canSaveItem() ? 'action' : 'disabled']" @click="saveItem()">Save Email Blast</div>
			<div v-if="listDetail.email_blast_id" class="button neutral" @click="deleteItem()">Delete Email Blast</div>
			<div class="button neutral" @click="backToList()">Back to List</div>
		</div>
		<div v-else class="button action" @click="addItem()">New Email Blast</div>
	</div>

	<loading v-if="loading" class="loading"></loading>

	<div v-else-if="showDetail" class="detail">
		<div class="one-two-columns">
			<div>
				<h2>Details</h2>
				<label-required label="Title" :condition="listDetail.title" />
				<input type="text" v-model="listDetail.title" />
				<label>Sub Title</label>
				<input type="text" v-model="listDetail.sub_title" />
				<label>Intro Content</label>
				<textarea v-model="listDetail.content" />
			</div>
			<div>
				<h2>Template</h2>
				<div class="one-two-columns">
					<div>
						<label-required label="Current Template" :condition="listDetail.email_blast_template_id" />
						<img :src="listDetail.template_image" />
					</div>
					<div>
						<label>Select a Template</label>
						<div class="five-columns" style="border: 1px solid #ccc; height: 280px; overflow-y: scroll;">
							<div v-for="(template, index) in templates" class="pointer" @click="setTempalte(template)">
								<img :src="template.template_image" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<input type="checkbox" value="1" v-model="listDetail.include_catalogs" :checked="listDetail.include_catalogs" /> Include links to your Rifles, Handguns and Accessories at the bottom of your email?
		<h2>Products</h2>
	    <table class="data-list" width="100%" cellpadding="9" cellspacing="0">
			<thead>
				<tr>
					<th class="list"></th>
					<th class="list center"></th>
					<th class="list left">Description</th>
					<th class="list left">UPC</th>
					<th class="list right">Available</th>
					<th class="list right">Price</th>
					<th class="list center"></th>
				</tr>
			</thead>
			<draggable handle=".drag" :sort="true" v-model="listDetail.products" @end="endDrag" group="menu_items" tag="tbody">
			<tr v-for="(product, index) in listDetail.products" class="draggable">
				<td class="list drag"><i class="fas fa-grip-vertical"></i></td>
				<td class="list center" width="40"><img :src="product.image_src" /></td>
				<td class="list left">{{ product.description }}</td>
				<td class="list left">{{ product.upc }}</td>
				<td class="list right">{{ product.available }}</td>
				<td class="list right">{{ product.price }}</td>
				<td class="list right extra-menu" @click="setOverride(product)">
					<div :class="['button', product.has_override ? 'action' : 'neutral', 'smaller', 'spaced']"><i class='fa fa-dollar-sign' /></div>
					<div :class="[product.has_override ? 'action' : 'neutral', 'extra-menu-label']">{{ product.has_override ? 'Override Active' : 'Add Price Override' }}</div>
				</td>
				<td class="list right">
					<div class="button neutral smaller" @click="removeProduct(product)"><i class='fa fa-trash' /></div>
				</td>
			</tr>
			</draggable>
		</table>
		<div class="controls">
			<div class="button action" @click="addingProducts = true">Add products</div>
		</div>

		<div v-if="listDetail.preview_link" style="margin: 1em 0;">
			<label>Preview this email... </label>
			<a :href="listDetail.preview_link" target="_blank">{{ listDetail.preview_link }}</a>
		</div>

		<div v-if="listDetail.preview_link" style="margin: 1em 0;">
			<div>Copy and paste this email's code to send it through Mailchimp or another email service.</div>
			<div class="button neutral small v-spaced" @click="showEmailSourceCode()">Show Email code</div>
		</div>

	</div>

	<div v-else class="list">

	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>

	    <table v-else class="data-list" cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th></th>
					<th class="list left">Created</th>
					<th class="list left">Title</th>
					<th class="list left">Sub Title</th>
				</tr>
			</thead>
			<tr v-for="(item, index) in list" class="clickable-list-item" @click="getItem(item)">
				<td class="list center"><img :src="item.template_image" style="width: 60px;" /></td>
				<td class="list left">{{ item.date_created }}</td>
				<td class="list left">{{ item.title }}</td>
				<td class="list left">{{ item.sub_title }}</td>
			</tr>
		</table>

	</div>
	
    <message-modal v-if="message" :message="message" :loading="saving" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" @action="doMessageModalAction()" />

	<div v-if="htmlText" class="modal" style="z-index:1;">
		<div class="inner" style="max-width: inherit; max-height: inherit; width: 66vw;">
			<h2>Email Blast Code</h2>
			<div class="content" style="max-height: inherit; height: 24em;">
				<pre>{{ htmlText }}</pre>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="htmlText = ''">Cancel</div>
				<div class="button action spaced" @click="copySourceCode">{{ codeCopied }}</div>
			</div>
		</div>
	</div>

	<price-override-detail v-if="showPriceOverride" :listDetail="priceOverride" @backToList="finishedPriceOverride" />

	<product-search v-if="addingProducts" searchFor="Email Blast" @assignProduct="assignProduct" @cancel="addingProducts = false" />

	<help-popup :helpLink="{117:'Email Blasts', 367:'Create an Email Blast', 368:'Send an Email Blast', 120:'Export Customer List'}" :tours="false"></help-popup>

</div>

</template>

<script>
import Loading from '@/components/Loading.vue'
import LabelRequired from '@/components/LabelRequired.vue'
import ProductSearch from '@/components/ProductSearch.vue'
import PriceOverrideDetail from '@/components/PriceOverrideDetail.vue'
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'email-blasts',
    components: {
        'loading': Loading,
		'label-required': LabelRequired,
		'product-search': ProductSearch,
		'price-override-detail': PriceOverrideDetail,
		'help-popup': HelpPopup
    },
	data() {
		return {
            loading: false,
			filters: {},
			list: [],
			paging: {},
			templates: [],
			showDetail: false,
			listDetail: {},
			message: '',
			addingProducts: false,
			product_filters: {},
			loadingProducts: false,
			departments: [],
			manufacturers: [],
			loadingManufacturers: false,
			searchedProducts: [],
			productPaging: {},
			selectedProducts: [],
			saveMessage: '',
			saving: false,
			messageStatus: '',
			messageTimeout: 0,
			htmlText: '',
			priceOverride: {},
			showPriceOverride: false,
			codeCopied: 'Copy Code'
		}
	},
	created() {
		this.clearFilters()
	},
	computed: {
		canSave() {
			return true
		}
	},
	methods: {
		clearFilters() {
			this.filters = {
				page: 1,
				search_term: '',
				internal_use_only: 0,
				inactive: 0
			}
			this.getList()
		},
		getList() {
			if (this.loading) { return }
			this.loading = true
			this.apiCall({ destination: 'get_list_email_blasts', data: this.filters }).then(obj => {
				this.loading = false
				this.list = obj.list
				if (obj.paging) {
					this.paging = obj.paging
				}
				if (obj.templates) {
					this.templates = obj.templates
				}
			}).catch(err => {
				console.log(err)
			})
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		getItem(item) {
			if (this.loading) { return }
			this.loading = true
			this.apiCall({ destination: 'get_item_email_blast', data: { email_blast_id: item.email_blast_id } }).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					this.listDetail = obj.detail
					// reset preview link with current domain
					// if (this.getDevEnvironment) {
					// 	this.listDetail.preview_link = this.getApiHost + '/legacy/emailblast.php?id=' + this.listDetail.email_blast_id
					// } else {
					// 	this.listDetail.preview_link = document.location.hostname + '/legacy/emailblast.php?id=' + this.listDetail.email_blast_id
					//}
					this.showDetail = true
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		setTempalte(template) {
			this.listDetail.email_blast_template_id = template.email_blast_template_id
			this.listDetail.template_image = template.template_image
		},
		addItem() {
			this.listDetail = {
				title: '',
				email_blast_template_id: '',
				products: [],
				internal_use_only: 0,
				inactive: 0
			}
			this.showDetail = true
		},
		canSaveItem() {
			return this.listDetail.title && this.listDetail.email_blast_template_id && this.listDetail.products.length > 0
		},
		saveItem() {
			if (this.saving) { return false }
			if (!this.canSaveItem()) { return false }
			this.saving = true
			this.message = 'Saving email blast'
			this.messageStatus = ''
			this.messageTimeout = 0
			this.apiCall({ destination: 'save_item_email_blast', data: this.listDetail }).then(obj => {
				this.saving = false
				this.messageStatus = obj.status
				if (obj.status == 'success') {
					this.listDetail.email_blast_id = obj.email_blast_id
					this.listDetail.preview_link = obj.preview_link
					this.message = 'Email blast saved!'
					this.messageTimeout = 3000
				}
			}).catch(err => {
				console.log(err)
				this.saving = false
				this.messageStatus = 'error'
				this.message = 'Failed to save email blast. Please check your connection and try again.'
			})
		},
		deleteItem() {
			// NOTE: this show modal to in turn call an api action to delete the item
			this.message = 'Delete email blast?'
			this.messageStatus = 'delete'
			this.messageTimeout = 0
		},
		doMessageModalAction() {
			switch (this.messageStatus) {
				case 'delete':
					this.message = 'Deleting email blast...'
					this.messageStatus = 'waiting'
					this.apiCall({ destination: 'delete_item_email_blast', data: { email_blast_id: this.listDetail.email_blast_id } }).then(obj => {
						this.messageStatus = obj.status
						this.message = 'Email blast deleted!'
						this.messageTimeout = 3000
						this.backToList()
					}).catch(err => {
						console.log(err)
					})
					break;
			}
		},
		setOverride(product) {
			this.priceOverride = product
			this.showPriceOverride = true
		},
		finishedPriceOverride(updateRequired) {
			if (updateRequired && this.listDetail.email_blast_id) {
				this.getItem(this.listDetail)
			}
			this.showPriceOverride = false
		},
		removeProduct(product) {
			for (var index = 0; index < this.listDetail.products.length; index++) {
				if (this.listDetail.products[index].product_id == product.product_id) {
					this.listDetail.products.splice(index, 1);
				}
			}
		},
		endDrag(event) {
			let sortedProducts = []
			sortedProducts = this.listDetail.products.map((product, index) => {
				product.sort_order = index + 1
				return product
			})
			this.listDetail.products = sortedProducts
		},
		assignProduct(product) {
			this.addingProducts = false
			// make sure it's not already in the list
			let inList = false
			this.listDetail.products.forEach(row => {
				if (row.product_id == product.product_id) {
					inList = true
				}
			})
			if (!inList) {
				this.listDetail.products.push(product)
			}
		},
		showEmailSourceCode() {
			if (!this.listDetail.preview_link && this.loading) { return }
			this.loading = true
			if (this.getDevEnvironment) {
				this.loading = false
				this.htmlText = 'Get code not available in dev environment'
			} else {
				this.apiCall({ destination: 'get_email_blast_html', data: { preview_link: this.listDetail.preview_link } }).then(obj => {
					this.loading = false
					if (obj.status == 'success') {
						this.htmlText = atob(obj.html);
					} else {
						if (obj.errno && obj.error) {
							this.htmlText = 'Error retrieving html ' + '\n\n' + 'Error Code ' + obj.errno  + ' -- ' + obj.error + '\n\n' + 'Please submit a support ticket'
						} else {
							this.htmlText = 'Error retrieving html, please submit a support ticket'
						}
					}
				}).catch(err => {
					console.log(err)
				})
			}
		},
		copySourceCode() {
			navigator.clipboard.writeText(this.htmlText);
			this.message = 'Code Copied!'
			this.messageTimeout = 3000
		},
		backToList() {
			this.getList()
			this.listDetail = {}
			this.showDetail = false
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
